export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/a2cdf02300b2663230f496dbfe02b4a0.svg";